export const SPACE = " ";
